import React, { useEffect, useState } from "react";
import Apiservice from "../Apiservice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { formatDateTimeQuiz } from '../Utils/Utils';


const SOP = () => {
    const navigate = useNavigate();
   const [roleId, setRoleId] = useState(() => localStorage.getItem('role_id'));

    const [sop, setSOP] = useState([]);

    useEffect(() => {

        fetchData();
    }, []);

    const fetchData = async () => {
        let data = {
            status: 0,
        };
        let result = await Apiservice.SOPGet(data);
        if (result.success === true) {
            setSOP(result.data);
        } else {
            alert(result.message);
        }
    };
    const handleSoftDelete = async (id) => {
        Swal.fire({
            title: "Are you sure you want to delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await Apiservice.SOPSoftDelete({ sopId: id });

                    if (response.success) {

                        Swal.fire({
                            title: "Deleted!",
                            text: "Your file has been deleted.",
                            icon: "success",
                        });
                        // optionally refresh list
                        fetchData();
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message || "Something went wrong.",
                            icon: "error",
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete. Please try again.",
                        icon: "error",
                    });
                }
            }
        });
    };

    const handleAdd = async () => {
        navigate('/sopadd')
    }


    return (
        <div className="container-fluid shadow p-2">
            <div className="row text-center">
                <div className="col">
                    <h3>SOP</h3>
                </div>
            </div>
            {
                roleId == 1 && (
                    <div className="row mb-2">
                        <div className="col text-end">
                            <button className="btn btn-sm btn-primary" onClick={handleAdd}>Add</button>
                        </div>
                    </div>
                )
            }

            <div className="row">
                <div className="col">
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover align-middle">
                            <thead className="table-dark text-center">
                                <tr>
                                    <th style={{ width: "5%" }}>#</th>
                                    <th style={{ width: "15%" }}>Date & Time</th>
                                    <th style={{ width: "15%" }}>Title</th>
                                    <th style={{ width: "20%" }}>Description</th>
                                    {
                                        roleId == 1 && (
                                            <th style={{ width: "15%" }}>Sites</th>
                                        )
                                    }

                                    <th style={{ width: "20%" }}>Files</th>
                                    {
                                        roleId == 1 && (
                                            <th style={{ width: "10%" }}>Action</th>
                                        )
                                    }

                                </tr>
                            </thead>
                            <tbody>
                                {sop.length > 0 ? (
                                    sop.map((item, index) => {
                                        const createdDate = new Date(item.createdAt);
                                        const datePart = createdDate.toLocaleDateString("en-GB"); // DD/MM/YYYY
                                        const timePart = createdDate.toLocaleTimeString("en-GB"); // HH:mm:ss

                                        return (
                                            <tr key={item.id}>
                                                {/* Serial Number */}
                                                <td className="text-center fw-semibold">{index + 1}</td>

                                                {/* Date & Time */}
                                                <td>
                                                    <div className="fw-semibold">{datePart}</div>
                                                    <div className="text-muted small">{timePart}</div>
                                                </td>

                                                {/* Title */}
                                                <td className="fw-bold">{item.title}</td>

                                                {/* Description */}
                                                <td>{item.description}</td>

                                                {/* Sites */}
                                                {
                                                    roleId == 1 && (
                                                        <td>
                                                            {item.siteDetails && item.siteDetails.length > 0 ? (
                                                                <ol className="mb-0 ps-3">
                                                                    {item.siteDetails.map((site) => (
                                                                        <li key={site.id} className="mb-1">
                                                                            {site.name}
                                                                        </li>
                                                                    ))}
                                                                </ol>
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </td>
                                                    )
                                                }


                                                {/* Files */}
                                                <td>
                                                    {item.files && item.files.length > 0 ? (
                                                        <ol className="mb-0 ps-3">
                                                            {item.files.map((file, i) => {
                                                                const fullName = file.split("/").pop();
                                                                const displayName = fullName.includes("-")
                                                                    ? fullName.substring(fullName.indexOf("-") + 1)
                                                                    : fullName;

                                                                return (
                                                                    <li key={i} className="mb-1">
                                                                        <a
                                                                            href={file}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            className="text-decoration-none"
                                                                        >
                                                                            {displayName}
                                                                        </a>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ol>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>

                                                {/* Actions */}
                                                {
                                                    roleId == 1 && (
                                                        <td className="text-center">
                                                            <button className="btn btn-sm btn-outline-warning me-2">
                                                                Edit
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-outline-danger"
                                                                onClick={() => handleSoftDelete(item.id)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </td>
                                                    )
                                                }

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-3">
                                            No Data Available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default SOP;
